import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, CanActivate } from '@angular/router';

import { Observable } from 'rxjs';

import { AuthService } from './auth.service';

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate {

	constructor(private authService: AuthService) { }

	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean> | Promise<boolean> | boolean {
		const roles = route.data.roles as Array<string>;

		if (!roles) {
			throw Error('Roles not defined for guard.');
		}

		return this.authService.isAuthenticated
			&& roles.filter(x => this.authService.getUserRole().includes(x)).length > 0;
	}

}
